import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IProjectStage } from '@modules/projects/shared/interfaces/project-stage.interface';

@Injectable({ providedIn: 'root' })
export class ProjectDashboardStepperSyncService {
  private readonly stagesUpdatedSource = new Subject<{ projectId: number; stages: IProjectStage[] }>();
  readonly stagesUpdated$ = this.stagesUpdatedSource.asObservable();

  updateProjectStages(projectId: number, stages: IProjectStage[]): void {
    this.stagesUpdatedSource.next({ projectId, stages });
  }
}

